import React from 'react';
// import { useTranslation } from 'react-i18next';

import * as S from './styled';

const WrapperSection = ({ children, id }) => (
  <S.Wrapper id={id}>{children}</S.Wrapper>
);
export default WrapperSection;
